/** */
import { urls } from 'services/_url';
import { apiGet } from 'services/_http';

/** */
const base_url = `${urls.sales}/agencies`;

// Aggregated dashboard figures for an agency across the supplied orgs:
// earnings (total/pending/settled), total spends, and active/expiring subs.
export const readStats = async (options = {}) => {
  return await apiGet(`${base_url}/stats`, { ...options });
};

// Active subscriptions for the supplied orgs.
export const readSubscriptions = async (options = {}) => {
  return await apiGet(`${base_url}/subscriptions`, { ...options });
};

// Paid/unpaid invoice breakdown for the supplied orgs.
export const readInvoices = async (options = {}) => {
  return await apiGet(`${base_url}/invoices`, { ...options });
};
